import { render } from "./PageUpdateJadwalWawancara.vue?vue&type=template&id=0b2712b8"
import script from "./PageUpdateJadwalWawancara.vue?vue&type=script&lang=js"
export * from "./PageUpdateJadwalWawancara.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__